module.exports = __webpack_public_path__ + "static/media/LOGO.0482abdf.svg";